// extracted by mini-css-extract-plugin
export default {"SearchTabs":"SearchTabs3rNhUK3HjrRJ","SearchTabs-tab":"SearchTabs-tab1TrpmhQv840T"};